import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BuyMore = _resolveComponent("BuyMore")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "custom-class": "buy-more-wrap buy-more-drawer",
    title: _ctx.t('buyMore.drawerTitle'),
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: "70%",
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      (_ctx.modelValue)
        ? (_openBlock(), _createBlock(_component_BuyMore, {
            key: 0,
            "is-private": _ctx.isPrivate,
            onClose: _ctx.handleClose
          }, null, 8, ["is-private", "onClose"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "model-value", "onClose"]))
}